import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';
import '../assets/css/partnerProClub.scss';
import '../assets/css/partnerPortal/welcome.scss';
import '../assets/css/partnerPortal/homepage.scss';
import '../assets/css/partnerPortal/salesEnablement.scss';

import ButtonArrow from "./ButtonArrow";




function CardRole(props) {

    const [icon] = useState(props.icon);
    const [title] = useState(props.title);
    const [subTitle] = useState(props.subTitle);
    const [buttonLink] = useState(props.buttonLink);
    const [target] = useState(props.target);
    const [addMargin] = useState(props.addMargin);
    const [buttonName] = useState(props.buttonName);
    const [shapeHeight] = useState(props.shapeHeight);
    const [imageWidth] = useState(props.imageWidth);


    return (

        <div className={"d-flex align-items-center flex-column cardShape width24 " + shapeHeight}>
            <div className="d-flex align-items-center flex-column justify-content-end mt-5">
                <img src={icon} width={imageWidth ? imageWidth : "100%"} />
            </div>
            <div className={"d-flex flex-column align-items-center align-self-stretch justify-content-between " + addMargin }>
                <div className={"d-flex flex-column align-items-center "}>
                    <div className="d-flex align-items-start justify-content-center align-self-stretch cardTitleApp mb-2">{title}</div>
                    <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2 cardHeight">
                        {subTitle}
                    </div>
                </div>
                {/* <ButtonArrow link={buttonLink} buttonName={"Learn More"} width="15%" /> */}
            </div>
            <div>
           {buttonLink ? <ButtonArrow link={buttonLink} buttonName={buttonName ? buttonName : "Learn More"} target={target ? target :"_parent"} width="15%" className={"mb-5"} /> : ""}
            </div>
        </div>

    )


}

export default withRouter(CardRole);



